import { combineReducers, persistReducer, sessionStorage } from '@grandvisionhq/state';
import { reducer } from './bundles/reducer.js';
import { reducer as reducer$1 } from './configurations/reducer.js';
import { reducer as reducer$2 } from './prescription/reducer.js';
import { reducer as reducer$3 } from './products/reducer.js';
import { reducer as reducer$4 } from './configurator/reducer.js';

const getConfig = (key)=>({
        storage: sessionStorage,
        key
    })
;
var prescriptionGlassesReducer = combineReducers({
    bundles: reducer,
    configurations: persistReducer(getConfig('grandvision_pg_configurations'), reducer$1),
    prescription: persistReducer(getConfig('grandvision_pg_prescription'), reducer$2),
    products: reducer$3,
    configurator: reducer$4
});

export { prescriptionGlassesReducer as default, getConfig };
//# sourceMappingURL=reducer.js.map
